const storeObject = {
  store: null,
  getStore: () => storeObject.store,
};

export default storeObject;
